exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".brand-list[data-v-6d6668ca] {\n  padding: 0px 4.8%;\n  width: 100%;\n  margin-bottom: 20px;\n  background-color: #ffffff;\n}\n.brand-box[data-v-6d6668ca] {\n  display: grid;\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  grid-auto-rows: minmax(100px, auto);\n  margin-top: 10px;\n}\n.back[data-v-6d6668ca] {\n  margin-top: 20px;\n}", ""]);

// exports
